const ROOT_DOMAIN = 'officeguru.dk';

export { ROOT_DOMAIN }